import * as React from "react";
import styles from "./App.module.scss";
import LazyProductImage from "../../../components/lazy-product-image/lazy-product-image";
import { useTranslation } from "next-i18next";
import { getUserAgent } from "../../../utils/agent";
import { getLang } from "../../../utils/lang";
import { IUserAgent } from "../../../types/ua";
function AppNewComponent(props: { className?: string }) {
  const [userAgent, setUserAgent] = React.useState<IUserAgent>(
    {} as IUserAgent
  );
  React.useEffect(() => {
    const ua = getUserAgent();
    setUserAgent(ua);
  }, []);

  const { t, i18n } = useTranslation("common");

  return (
    <div className={`${styles.app} ${props.className || ""}`}>
      <div className={styles.content}>
        <div className={styles.text}>
          <p>{t("app")}</p>
          <div className={styles.stores}>
            {(userAgent.isMobile && !userAgent.isAndroid) ||
            !userAgent.isMobile ? (
              <>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className={`${styles.big} plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=app`}
                  title="Apple Store"
                  href="https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website"
                >
                  <LazyProductImage
                    width="182"
                    height="54"
                    alt="Apple Store"
                    src={`https://public.choose.app/website/new/images/btn-big-app-store-${getLang(
                      i18n
                    )}.svg`}
                  />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className={`${styles.small} plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=app`}
                  title="Apple Store"
                  href="https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website"
                >
                  <LazyProductImage
                    width="134"
                    height="40"
                    alt="Apple Store"
                    src={`https://public.choose.app/website/new/images/btn-small-app-store-${getLang(
                      i18n
                    )}.svg`}
                  />
                </a>
              </>
            ) : null}
            {(userAgent.isMobile && userAgent.isAndroid) ||
            !userAgent.isMobile ? (
              <>
                <a
                  href="https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR"
                  rel="noreferrer"
                  className={`${styles.big} plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=app`}
                  target="_blank"
                >
                  <LazyProductImage
                    width="182"
                    height="54"
                    alt="Play Store"
                    src={`https://public.choose.app/website/new/images/btn-big-play-store-${getLang(
                      i18n
                    )}.svg`}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR"
                  rel="noreferrer"
                  className={`${styles.small} plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=app`}
                  target="_blank"
                >
                  <LazyProductImage
                    height="41"
                    width="136"
                    alt="Play Store"
                    src={`https://public.choose.app/website/new/images/btn-small-play-store-${getLang(
                      i18n
                    )}.svg`}
                  />
                </a>
              </>
            ) : null}
          </div>
        </div>
        <img
          width="177"
          height="177"
          alt="HeartRotate"
          src="https://public.choose.app/website/new/images/HeartRotate.png"
          srcSet={`https://public.choose.app/website/new/images/HeartRotate@2x.png 2x,https://public.choose.app/website/new/images/HeartRotate@3x.png 3x`}
        />
      </div>
    </div>
  );
}

export default AppNewComponent;
